import { useQuery } from "@tanstack/react-query";
import axios from "const/axios";
import { API_URL } from "const/constants";

export const useVisaStatusHistory = (visaId, enabled = true) =>
  useQuery({
    queryKey: ["visa-status-history", visaId],
    queryFn: () =>
      axios
        .get(`${API_URL}/visa-applications/${visaId}/status-history`)
        .then((r) => r.data?.data ?? []),
    enabled: Boolean(enabled) && !!visaId,
    refetchOnWindowFocus: false,
  });

export const addVisaStatusEntry = (visaId, payload) =>
  axios.post(`${API_URL}/visa-applications/${visaId}/status-history`, payload);
